// Log from https://tools.ietf.org/  - RFC 5424 - [Page 10]
export enum LogLevel {
  ERROR = 3,
  WARN = 4,
  INFO = 6,
  DEBUG = 7,
}

export interface LoggerProps {
  tag: string;
  minLevel?: LogLevel;
}

export type LogWithLevel = (
  module: string,
  message: string,
  level?: LogLevel,
  props?: unknown,
  style?: string,
) => void;

export type ModuleLogWithLevel = (message: string, level?: LogLevel, props?: unknown) => void;

export type Log = (module: string, message: string, props?: unknown, style?: string) => void;

export type ModuleLog = (message: string, props?: unknown) => void;

export interface ModuleLoggerAPI {
  log: ModuleLogWithLevel;
  error: ModuleLog;
  warn: ModuleLog;
  info: ModuleLog;
  debug: ModuleLog;
}
export interface LoggerAPI {
  getModuleLogger: (module: string) => ModuleLoggerAPI;
  log: LogWithLevel;
  error: Log;
  warn: Log;
  info: Log;
  debug: Log;
}

export type ConsoleLogLevel = 'debug' | 'error' | 'info' | 'warn';
